import {BaseApi} from "@/core/api/base.api";
import { Room } from "@/core/api/room.api";
import {roomFileService} from "@/core/service/room.file.service";
import _ from "lodash";
import { RoomInfo } from '@/core/api/room.info.api'

class RoomFileApi extends BaseApi {
    #roomFile

    constructor() {
        super()
        Room.File = this;
        
        Room.ready(async e => {
            if(!RoomInfo.useModule('fileShare')){
                return;
            }

            this._eventListen(this.#Events);
            this.#roomFile = await this.getRoomFileList();
            Room.emit({
                type: 'room_file_init',
                data: _.cloneDeep(this.#roomFile),
            })
        });
    }

    #Events = {
        room_file_add(e) {
            Room.emit(e);
        },
        room_file_delete(e) {
            Room.emit(e);
        },
    }

    async getRoomFileList() {
        let {data = []} = await roomFileService.getRoomFileList();
        return data;
    }
    async getUploadUrl(uploadObj) {
        return (await roomFileService.getUploadUrl(uploadObj)).data
    }
    uploadRoomFile(data) {
        roomFileService.uploadRoomFile(data)
    }
    async uploadToPresignedUrl(data) {
        return await roomFileService.uploadToPresignedUrl(data)
    }
    async completeUploadToPresignedUrl(data) {
        return await roomFileService.completeUploadToPresignedUrl(data)
    }
    async deleteRoomFile(data){
        return await roomFileService.deleteRoomFile(data);
    }
    async getRoomFileUrl(data){
        return (await roomFileService.getRoomFileUrl(data)).data;
    }
    async uploadToSasUrl(data) {
        return await roomFileService.uploadToSasUrl(data);
    }
    
}

export const RoomFile = new RoomFileApi();